import { TFunction } from 'i18next';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Container } from 'reactstrap';

import { FullSizeMessage } from '../../components/FullSizeMessage';
import { Content } from '../../components/layout/Content';

interface Props {
  t: TFunction;
}

const AccessForbiddenComponent = ({ t }: Props) => (
  <Content>
    <Container className="min-vh-100">
      <FullSizeMessage
        description={t('accessForbidden.description')}
        headline={t('accessForbidden.heading')}
        iconKind="hand_forbidden"
      />
    </Container>
  </Content>
);

export const AccessForbidden = withTranslation()(AccessForbiddenComponent);
